import classNames from 'classnames';
import React from 'react';

interface IProgressBar {
  percentage: number;
}
const ProgressBar = (props: IProgressBar) => {
  const { percentage } = props;

  return (
    <div className="h-[10px] w-full rounded-md bg-card-bg-color">
      <div
        className={classNames(
          `h-[10px] bg-gradient-to-br from-primary to-secondary `,
          { 'rounded-md': percentage === 100 },
          { 'rounded-l-md': percentage !== 100 }
        )}
        style={{
          width: `${percentage}%`,
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
